"use strict";

exports.__esModule = true;
exports.ScrollableTable = exports.FirstColumn = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MinimalTable = _styledComponents["default"].table.withConfig({
  displayName: "table__MinimalTable",
  componentId: "sc-1oha3o-0"
})(["border-collapse:collapse;flex:1 0 auto;text-align:left;"]);

var FirstTable = (0, _styledComponents["default"])(MinimalTable).withConfig({
  displayName: "table__FirstTable",
  componentId: "sc-1oha3o-1"
})(["", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (min-width:", "px){min-width:180px;max-width:250px;}"], theme.breakpointInts[0]) : null;
});
var ScrollTable = (0, _styledComponents["default"])(MinimalTable).withConfig({
  displayName: "table__ScrollTable",
  componentId: "sc-1oha3o-2"
})(["width:", "px;"], function (_ref2) {
  var length = _ref2.length;
  return length * 200;
});
var HeadCell = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "table__HeadCell",
  componentId: "sc-1oha3o-3"
})(["border-bottom:1px solid ", ";letter-spacing:0.5px;"], function (props) {
  return (0, _styles.colors)("border", props);
});
var FirstHeadCell = (0, _styledComponents["default"])(HeadCell).withConfig({
  displayName: "table__FirstHeadCell",
  componentId: "sc-1oha3o-4"
})(["border-right:1px solid ", ";letter-spacing:0.5px;"], function (props) {
  return (0, _styles.colors)("border", props);
});
var Cell = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "table__Cell",
  componentId: "sc-1oha3o-5"
})(["border-top:1px solid ", ";max-height:", "px;vertical-align:top;"], function (props) {
  return (0, _styles.themeTransparentize)(0.4, "border", props);
}, function (props) {
  return props.height;
});

var Row = _styledComponents["default"].tr.withConfig({
  displayName: "table__Row",
  componentId: "sc-1oha3o-6"
})(["&:first-child{", "{border-top:none;}}"], Cell);

var FirstCell = (0, _styledComponents["default"])(Cell).withConfig({
  displayName: "table__FirstCell",
  componentId: "sc-1oha3o-7"
})(["border-right:1px solid ", ";vertical-align:top;"], function (props) {
  return (0, _styles.colors)("border", props);
});
var TableWrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "table__TableWrapper",
  componentId: "sc-1oha3o-8"
})(["position:absolute;left:0;top:0;"]);
var scrollableTableTropTypes = {
  /** An array of titles for categories */
  categories: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
    name: _propTypes.string
  })),

  /** Font styles config for fonts in table cell */
  cellFont: _utils.fontPropType,

  /** Font styles for title font in table cell */
  cellTitleFont: _utils.fontPropType,

  /** An array of products for display */
  data: (0, _propTypes.arrayOf)(_propTypes.object),

  /**
   * rowRefs is single ref that wraps a group of ref objects used to keep
   * track of each row's height
   */
  rowRefs: (0, _propTypes.shape)({
    current: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      current: _propTypes.object
    }))
  })
};

var ScrollableTable = function ScrollableTable(_ref3) {
  var categories = _ref3.categories,
      data = _ref3.data,
      cellTitleFont = _ref3.cellTitleFont,
      cellFont = _ref3.cellFont,
      rowRefs = _ref3.rowRefs;
  return /*#__PURE__*/_react["default"].createElement(TableWrapper, {
    pb: 3
  }, /*#__PURE__*/_react["default"].createElement(ScrollTable, {
    length: categories && categories.length
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
    ref: rowRefs.current[0]
  }, (0, _utils.mapIndexed)(function (_ref4, index) {
    var name = _ref4.name,
        id = _ref4.id;
    return /*#__PURE__*/_react["default"].createElement(HeadCell, _extends({
      key: id,
      "data-test-id": "modules-comparison-table-header-cell",
      height: 70,
      pl: index === 0 ? [3, 3, 5] : [2, 2, 3],
      pr: 3,
      tag: "th"
    }, cellTitleFont), name);
  }, categories))), /*#__PURE__*/_react["default"].createElement("tbody", null, (0, _utils.mapIndexed)(function (_ref5, index) {
    var id = _ref5.id,
        specs = _ref5.specs;
    return /*#__PURE__*/_react["default"].createElement(Row, {
      key: "row-" + id,
      "data-test-id": "modules-comparison-table-row",
      ref: rowRefs.current[index + 1]
    }, (0, _utils.mapIndexed)(function (_ref6, cellIndex) {
      var name = _ref6.name,
          idx = _ref6.id;
      return /*#__PURE__*/_react["default"].createElement(Cell, _extends({
        "data-test-id": "modules-comparison-table-cell",
        height: 102,
        pl: cellIndex === 0 ? [3, 3, 5] : [2, 2, 3],
        pr: 3,
        tag: "td"
      }, cellFont, {
        key: idx,
        color: !name ? "legal-grey" : cellFont.color,
        pt: 2
      }), name || "\u2014");
    }, specs));
  }, data))));
};

exports.ScrollableTable = ScrollableTable;
ScrollableTable.propTypes = scrollableTableTropTypes;
var firstColumnPropTypes = {
  /** An array of products for display */
  data: (0, _propTypes.arrayOf)(_propTypes.object),

  /** Font styles for products */
  productFont: _utils.fontPropType,

  /** Font styles for products title */
  productTitleFont: _utils.fontPropType,

  /** table row height */
  rowHeights: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object]),

  /** Font styles for type */
  typeFont: _utils.fontPropType
};

var FirstColumn = function FirstColumn(_ref7) {
  var data = _ref7.data,
      productTitleFont = _ref7.productTitleFont,
      productFont = _ref7.productFont,
      typeFont = _ref7.typeFont,
      rowHeights = _ref7.rowHeights;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    "data-test-id": "modules-comparison-table-first-column",
    pb: 3
  }, /*#__PURE__*/_react["default"].createElement(FirstTable, null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement(FirstHeadCell, _extends({
    pr: 1
  }, productTitleFont, {
    height: rowHeights && rowHeights[0] ? rowHeights[0] : 70,
    tag: "th",
    textAlign: "left"
  }), "Product"))), /*#__PURE__*/_react["default"].createElement("tbody", null, (0, _utils.mapIndexed)(function (product, index) {
    return /*#__PURE__*/_react["default"].createElement(Row, {
      key: "first-" + product.id
    }, /*#__PURE__*/_react["default"].createElement(FirstCell, {
      height: rowHeights && rowHeights[index + 1] ? rowHeights[index + 1] : 102,
      pr: 1,
      pt: 2,
      tag: "td"
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, product.chip && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      display: ["none", "flex"],
      mr: 2
    }, product.chip), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      flexDirection: "column"
    }, /*#__PURE__*/_react["default"].createElement(_components.Cta, _extends({
      tag: product.tag,
      url: product.url,
      version: "link"
    }, productFont), product.name), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
      textAlign: "left"
    }, typeFont), product.type)))));
  }, data))));
};

exports.FirstColumn = FirstColumn;
FirstColumn.propTypes = firstColumnPropTypes;
FirstColumn.displayName = "Modules.FirstColumn";